import { Injectable } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';

/**
 * @deprecated This service is deprecated. Please use {@link EpcotConfig} directly instead.
 */
@Injectable({ providedIn: 'root' })
export class EpcotConfigService {
    constructor(private epcotConfig: EpcotConfig) {}

    isEnabled(): boolean {
        return this.epcotConfig.isEnabled;
    }
}
